import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	leftArrowlabel: {
		id: 'version-issue-associated-designs.design-carousel.arrow.left-arrowlabel',
		defaultMessage: 'To next page',
		description: 'The accessbility label of the right icon button of design card carousel',
	},
	rightArrowlabel: {
		id: 'version-issue-associated-designs.design-carousel.arrow.right-arrowlabel',
		defaultMessage: 'To previous page',
		description: 'The accessbility label of the left icon button of design card carousel',
	},
});
